<template>
  <div>
    <CCol col="12" class="text-center">
      <CButton size="lg" color="warning" @click="$emit('click')">Try Again</CButton>
    </CCol>
  </div>
</template>

<script>
export default {
  name: "TryAgain"
}
</script>
